export default __webpack_public_path__ + "static/media/portfolio-47.cf9f3040.jpg";